<form [formGroup]="PerfilForm" novalidate>

    <div class="container border border-success rounded mt-2">
        <div class="alert " role="alert" *ngIf="cargandoDatos" class="alert-success">
            <h4 class="alert-heading">Cargando datos</h4>
            <hr>
            <p class="mb-0">Se está cargando la información.</p>
            <app-progress *ngIf="cargandoDatos"></app-progress>
        </div>
        <div class="container" *ngIf="!cargandoDatos">
            <div class="alert alert-info mt-2" role="alert">
                Ingresa tus antecedentes académicos siguiendo las instrucciones y completa la información antes de
                continuar. Preocúpate de que estén correctos, debido a que serán verificados más adelante. Al terminar
                pincha “Guardar y Continuar”.
            </div>
            <div class="card border border-success mt-3">
                <h5 class="card-header">Ingrese Antecedentes Educacionales
                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#IAE" role="button"
                        aria-expanded="true" aria-controls="IAE"></a>
                </h5>
                <div class="collapse show" id="IAE">
                    <div class="card-body">
                        <div class="row mt-2 container">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    id="EnsenhazaMediaEextranjero"
                                                    formControlName="EnsenhazaMediaEextranjero"
                                                    (change)="changeCertLem()">
                                                <label class="form-check-label" for="EnsenhazaMediaEextranjero">
                                                    ¿Estudió Enseñanza Media en el extranjero?
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 container"
                            *ngIf="PerfilForm.controls.EnsenhazaMediaEextranjero.value == true">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    id="PrimeroMedioExterior" formControlName="PrimeroMedioExterior">
                                                <label class="form-check-label" for="PrimeroMedioExterior">
                                                    Primero Medio Exterior
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    id="SegundoMedioExterior" formControlName="SegundoMedioExterior">
                                                <label class="form-check-label" for="SegundoMedioExterior">
                                                    Segundo Medio Exterior
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"
                                                    id="TerceroMedioExterior" formControlName="TerceroMedioExterior">
                                                <label class="form-check-label" for="TerceroMedioExterior">
                                                    Tercero Medio Exterior
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="CuartoMedioExterior"
                                                    formControlName="CuartoMedioExterior">
                                                <label class="form-check-label" for="CuartoMedioExterior">
                                                    Cuarto Medio Exterior
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2 container"
                            *ngIf="!PerfilForm.controls.PrimeroMedioExterior.value == true || !PerfilForm.controls.SegundoMedioExterior.value == true
                        || !PerfilForm.controls.TerceroMedioExterior.value == true || !PerfilForm.controls.CuartoMedioExterior.value == true">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="CuarsandoCuartoMedio"
                                            formControlName="CuarsandoCuartoMedio" (change)="changeCertLem()">
                                        <label class="form-check-label" for="CuarsandoCuartoMedio">
                                            Estoy cursando cuarto medio
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 container"
                            *ngIf="!PerfilForm.controls.PrimeroMedioExterior.value == true || !PerfilForm.controls.SegundoMedioExterior.value == true
                        || !PerfilForm.controls.TerceroMedioExterior.value == true || !PerfilForm.controls.CuartoMedioExterior.value == true">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <label>Año de Egreso de Enseñanza Media</label>
                                        <select formControlName="AnhoEgresoEM" class="form-control form-control-sm">
                                            <option value="" selected>Seleccione</option>
                                            <option *ngFor="let anho of AnhosEgresos" value={{anho.Value}}>
                                                {{anho.Text}}</option>
                                        </select>

                                    </div>
                                    <div class="col-sm-6"
                                        *ngIf="!PerfilForm.controls.PrimeroMedioExterior.value == true || !PerfilForm.controls.SegundoMedioExterior.value == true
                                    || !PerfilForm.controls.TerceroMedioExterior.value == true || !PerfilForm.controls.CuartoMedioExterior.value == true">
                                        <label>Región de Estudió</label>
                                        <select formControlName="RegionEstudio" class="form-control form-control-sm"
                                            (change)="ChangeRegionColegio($event)">
                                            <option value="" selected>Seleccione</option>
                                            <option *ngFor="let regione of RegionesColegios" value={{regione.Id}}>
                                                {{regione.Nombre}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 container"
                            *ngIf="!PerfilForm.controls.PrimeroMedioExterior.value == true || !PerfilForm.controls.SegundoMedioExterior.value == true
                        || !PerfilForm.controls.TerceroMedioExterior.value == true || !PerfilForm.controls.CuartoMedioExterior.value == true">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-sm-6">
                                        <label>Establecimiento Educacional</label>
                                        <br>
                                        <mat-form-field style="width: 100%!important;">
                                            <mat-select formControlName="EstablecimientoEducacionl"
                                                name="establecimientos"
                                                (selectionChange)="changeEstablecimiento($event)">
                                                <ngx-mat-select-search [placeholderLabel]="'Buscar establecimiento'"
                                                    [noEntriesFoundLabel]="'No se encuentra establecimiento'"
                                                    name="search" (keyup)="keyPressFilterEstab($event)">
                                                </ngx-mat-select-search>
                                                <mat-option
                                                    *ngFor="let estableciminto of Establecimientos | stringFilterBy:searchCtrl:'Nombre'"
                                                    [value]="estableciminto.Id">
                                                    {{estableciminto.Nombre}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-6">
                                        <label>Tipo de Dependencia</label>
                                        <select disabled class="form-control form-control-sm"
                                            formControlName="TipoDependencia">
                                            <option *ngFor="let dep of result_Dependencia.data" value="{{ dep.Id }}">
                                                {{ dep.Nombre }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card border border-success mt-2"
                *ngIf="!PerfilForm.controls.PrimeroMedioExterior.value == true || !PerfilForm.controls.SegundoMedioExterior.value == true
            || !PerfilForm.controls.TerceroMedioExterior.value == true || !PerfilForm.controls.CuartoMedioExterior.value == true">
                <h5 class="card-header">Ingrese sus Notas Enseñanza Media
                    <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#INEM" role="button"
                        aria-expanded="true" aria-controls="INEM"></a>
                </h5>
                <div class="collapse show" id="INEM">
                    <div class="card-body">
                        <div class="row mt-2 container">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="CursoEM2x1"
                                            formControlName="CursoEM2x1">
                                        <label class="form-check-label" for="CursoEM2x1">
                                            Cursé la Enseñanza Media bajo la modalidad 2x1
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 container" *ngIf="PerfilForm.controls.CursoEM2x1.value == true">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="PrimeroMedio2x1"
                                                    formControlName="PrimeroMedio2x1">
                                                <label class="form-check-label" for="PrimeroMedio2x1">
                                                    Primero Medio 2x1
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="SegundoMedio2x1"
                                                    formControlName="SegundoMedio2x1">
                                                <label class="form-check-label" for="SegundoMedio2x1">
                                                    Segundo Medio 2x1
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="TerceroMedio2x1"
                                                    formControlName="TerceroMedio2x1">
                                                <label class="form-check-label" for="TerceroMedio2x1">
                                                    Tercero Medio 2x1
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" id="CuartoMedio2x1"
                                                    formControlName="CuartoMedio2x1">
                                                <label class="form-check-label" for="CuartoMedio2x1">
                                                    Cuarto Medio 2x1
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 container">
                            <div class="alert alert-info" role="alert"
                                *ngIf="PerfilForm.controls.CursoEM2x1.value == true">
                                Debe repetir la nota de EM obtenida en el 2x1 en cada uno de los cursos realizados bajo
                                esa modalidad
                            </div>
                            <div class="col-md-12">
                                <div class="alert alert-info" role="alert">
                                    Ingrese notas de Enseñanza Media con decimales
                                </div>
                                <div class="form-group row">

                                    <div class="col-sm-3">
                                        <label>Nota 1° medio</label>
                                        <input type="number" numbersOnly class="form-control form-control-sm"
                                            formControlName="NotaPrimeroMedio" placeholder="Ingresar nota de 4 a 7"
                                            (change)="ChangeNota1($event)" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"
                                            step="0.01">

                                    </div>
                                    <div class="col-sm-3">
                                        <label>Nota 2° medio</label>
                                        <input type="number" numbersOnly class="form-control form-control-sm"
                                            formControlName="NotaSegundoMedio" placeholder="Ingresar nota de 4 a 7"
                                            (change)="ChangeNota2($event)" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"
                                            step="0.01">

                                    </div>
                                    <div class="col-sm-3">
                                        <label>Nota 3° medio</label>
                                        <input type="number" numbersOnly class="form-control form-control-sm"
                                            formControlName="NotaTerceroMedio" placeholder="Ingresar nota de 4 a 7"
                                            (change)="ChangeNota3($event)" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"
                                            step="0.01">

                                    </div>
                                    <div class="col-sm-3">
                                        <label>Nota 4° medio</label>
                                        <input type="number" numbersOnly class="form-control form-control-sm"
                                            formControlName="NotaCuartoMedio" placeholder="Ingresar nota de 4 a 7"
                                            (change)="ChangeNota4($event)" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/"
                                            step="0.01">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 container">
                            <div class="col-md-12">
                                <div class="form-group row">

                                    <div class="alert alert-info" role="alert">
                                        Si rendiste la PSU para el período de admisión 2019, ingresa tu puntaje a
                                        continuación, si rendiste la PSU en períodos de admisión anteriores, no es
                                        necesario que lo ingreses
                                    </div>
                                    <div class="col-sm-4">
                                        <label>Puntaje Promedio de PSU/PDT</label>
                                        <input type="number" numbersOnly class="form-control form-control-sm"
                                            formControlName="PuntajePromedioPsu"
                                            placeholder="Ingresar promedio PSU/PDT de 0 a 850"
                                            (change)="ChangePromedioPsu($event)">

                                    </div>
                                    <div class="col-sm-4">
                                        <label>Año PSU/PDT</label>
                                        <select formControlName="AnhoPsu" class="form-control form-control-sm">
                                            <option value="" selected>Seleccione</option>
                                            <option *ngFor="let anho of AnhoPsu" value={{anho.Value}}>
                                                {{anho.Text}}</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4">
                                        <label>Ranking</label>
                                        <input type="number" numbersOnly class="form-control form-control-sm"
                                            formControlName="Ranking" placeholder="Ingresar ranking de 0 a 850"
                                            (change)="ChangeRanking($event)">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 container" style="display: none;">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="CertificadoCulminacionEM"
                                            formControlName="CertificadoCulminacionEM" (change)="changeCertLem()">
                                        <label class="form-check-label" for="CertificadoCulminacionEM">
                                            Certificado de Culminación de Enseñanza Media
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-2 mt-2" *ngIf="!cargandoDatos && faseActual === '2'">
        <div class="col-md-3">&nbsp;</div>
        <div class="col-md-3 mr-2">
            <app-apibutton text="Guardar" [progress]="progress" (click)="Guardar()" *ngIf="habilitaBotones">
            </app-apibutton>
        </div>
        <div class="col-md-3 ml-2">
            <app-apibutton text="Guardar y continuar" [progress]="progress" (click)="GuardarContinuar()"
                *ngIf="habilitaBotones"></app-apibutton>
        </div>
        <div class="col-md-3">&nbsp;</div>
    </div>
</form>